import {useTranslation} from 'next-i18next';
import React, {FC, memo, ReactElement, ReactNode} from 'react';

import BenefitsList from '@/src/signUp/layoutSingUp/componetns/BenefitsList';
import InfoSection from '@/src/signUp/layoutSingUp/componetns/InfoSection';
import PartnersList from '@/src/signUp/layoutSingUp/componetns/PartnersList';
import SignupProgress from '@/src/signUp/layoutSingUp/componetns/SignupProgress';
import {Separator} from '@/src/ui';

import css from '../styles/SignupBenefitsLayout.module.css';

interface SignupBenefitsLayoutProps {
  children: ReactNode;
  step?: 1 | 2;
}

const SignupBenefitsLayout: FC<SignupBenefitsLayoutProps> = ({
  children,
  step,
}): ReactElement => {
  const {t} = useTranslation('common');

  return (
    <div className={css.main}>
      <div className={css.leftContent}>
        <InfoSection title={t('sign-up.our-benefits')}>
          <BenefitsList />
        </InfoSection>
        <div className={css.borderWrapper}>
          <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
        </div>
        <InfoSection title={t('sign-up.our-partners')}>
          <PartnersList />
        </InfoSection>
      </div>
      <div className={css.rightContent}>
        <SignupProgress step={step} />
        {children}
      </div>
    </div>
  );
};

export default memo(SignupBenefitsLayout);
